import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import Users from "../Components/Layout/elements/ChartUsers";
import { useDispatch, useSelector } from "react-redux";
import CreateTeacherModal from "../modals/CreateTeacherModal";
import ConfirmModal from "../modals/ConfirmModal";
import moment from "moment/moment";
import { Decryptedid, Encryptedid } from "../Util/BcruptEncyptid";
import LoaderComponent from "../Components/common/LoaderComponent";
import UserProfile from "../Components/common/UserProfile";
import StudentsModal from "../modals/StudentsModal";
import { Form } from "react-bootstrap";
import { convertTime } from "../Util/HelperFunction";
import WeekPicker from "../Components/common/WeekPicker";
import CreateAdminModal from "../modals/CreateAdminModal";
import { adminDetailAction } from "../Redux/Action/ManageAdminAction";

export default function AdminDetail() {
  const Userstore = useSelector((state) => state?.authSlice.userData?.payload);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const idval = Decryptedid(atob(id));
  const [isLoading, setIsLoading] = useState(false);
  const [selectedType, setSelectedType] = useState(" ");
  const [showStudentModal, setShowStudentModal] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [WeekCount, setWeekCount] = useState(0);
  const [selectedWeek, setSelecteWeek] = useState("");
  const [selecteDates, setSelecteDates] = useState({
    startOfWeek: "",
    endOfWeek: "",
  });

  useEffect(() => {
    setIsLoading(true);
    dispatch(adminDetailAction(idval)).finally(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  const adminDetail = useSelector(
    (state) => state?.manageAdminSlice?.adminDetail
  );

  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleSuspend = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleResPassword = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleCloseCreate = () => {
    setShowCreate(false);
    dispatch(adminDetailAction(idval));
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
    dispatch(adminDetailAction(idval));
  };

  const handleCloseStudentModal = () => {
    setShowStudentModal(false);
  };
  const handleOpenStudentModal = () => {
    setShowStudentModal(true);
  };

  const handleDetailClick = (data) => {
    navigate(`/student-detail/${Encryptedid(data._id)}`);
  };

  const handleRoleChange = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

    const handleClick = (data) => {
      navigate(`/collection-detail/${Encryptedid(data._id)}`);
    };
  

  return (
    <Layout>
      {isLoading ? (
        <LoaderComponent />
      ) : (
        <>
          <Container fluid>
            <Row className="mt-2">
              <Col lg={10}></Col>
              <Col
                lg={2}
                className="d-flex align-items-center justify-content-end"
              >
                <div className="d-flex top-bar">
                  {/* <UserProfile image={Userstore.image} /> */}
                </div>
              </Col>
              <Col
                lg={8}
                className="d-flex justify-content-start align-items-center"
              >
                {" "}
                <div className="heading-top pe-0 ps-0">
                  <p>
                    All Admin / {adminDetail.firstName} {adminDetail.surName}
                  </p>
                  <div className="back-page-title">
                    {/* <Link to="/manage-admin">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.75 5.5L8.25 11L13.75 16.5"
                          stroke="#CCD2E3"
                          strokeWidth="2"
                        />
                      </svg>
                    </Link> */}
                    <button onClick={() => navigate(-1)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                      >
                        <path
                          d="M13.75 5.5L8.25 11L13.75 16.5"
                          stroke="#CCD2E3"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>
                    <h2>
                      {adminDetail.firstName} {adminDetail.surName}
                    </h2>
                  </div>
                </div>
              </Col>

              <Col
                lg={4}
                className="d-flex gap-2 justify-content-end align-items-center mb-4 mb-md-0"
              >
                <button
                  className="cmn-pink"
                  onClick={() => handleRoleChange("adminToTeacher")}
                >
                  Convert to Teacher
                </button>
                <button
                  className="pink-border mb-0"
                  onClick={() => handleDelete("deleteAdmin")}
                >
                  Delete
                </button>
              </Col>
              {/* <Col
                lg={2}
                className="d-flex justify-content-end align-items-center"
              >
               
              </Col> */}
            </Row>
            <Row className="my-3">
              <Col xxl={4} lg={4} className="display-table">
                {" "}
                <div className="cmn-card-color table-cell">
                  <div className="student-view teacher">
                    <img
                      src={
                        adminDetail.image
                          ? adminDetail.image
                          : require("../Assets/Images/girl.png")
                      }
                    />
                    <h2>
                      {adminDetail.firstName} {adminDetail.surName}
                    </h2>
                    <p>{adminDetail?.schoolId?.schoolName}</p>
                    <p>{adminDetail?.department}</p>
                    <button
                      className="edit-btn"
                      onClick={() => setShowCreate(true)}
                    >
                      <img src={require("../Assets/Images/edit.svg").default} />
                    </button>
                    <div className="students-dates">
                      <div>
                        <h3>
                          {" "}
                          {adminDetail?.updatedAt
                            ? moment(adminDetail?.updatedAt).format(
                                "DD/MM/YYYY"
                              )
                            : null}
                        </h3>
                        <p>Created</p>
                      </div>
                      <div>
                        <h3>
                          {adminDetail?.lastActiveDate
                            ? moment(adminDetail?.lastActiveDate).format(
                                "DD/MM/YYYY"
                              )
                            : "---"}
                        </h3>
                        <p>Last Active</p>
                      </div>
                    </div>
                    <div className="students-dates">
                      <div>
                        <p>Contact</p>
                        <h3>E: {adminDetail.email}</h3>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center flex-column align-items-center">
                      <button
                        className="reset-pass mt-2"
                        onClick={() => handleSuspend("suspendAdmin")}
                      >
                        Suspend Account
                      </button>
                      <button
                        className="reset-pass mt-2"
                        onClick={() => handleResPassword("resAdminPassword")}
                      >
                        Reset Password
                      </button>
                      <button
                        className="reset-pass mt-2"
                        onClick={() => handleDelete("deleteAdmin")}
                      >
                        Delete Account
                      </button>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xxl={4} md={12} className="display-table">
                <div className="class-detail-sec teacher table-cell">
                  <div className="d-flex justify-content-between">
                    <h2>Collections</h2>
                  </div>
                  <div className="scroll-add position-relative">
                    <Row>
                      <>
                        {Array.isArray(adminDetail?.collectionId) &&
                        adminDetail?.collectionId.length > 0 ? (
                          <>
                            {adminDetail?.collectionId.map((ele, index) => (
                              // <Col lg={12} className="mt-2" key={index}>
                              //   <div className="collection-video-inner">
                              //     <Row>
                              //       <Col lg={3} md={3}>
                              //         <img
                              //           src={
                              //             ele?.image
                              //               ? ele?.image
                              //               : require("../Assets/Images/diceimage.png")
                              //           }
                              //         />
                              //       </Col>
                              //       <Col
                              //         lg={7}
                              //         md={7}
                              //         className="d-flex align-items-center"
                              //       >
                              //         <h3>{ele?.name}</h3>
                              //       </Col>
                              //       <Col lg={2} md={2}>
                              //         <p>
                              //           {Array.isArray(ele?.video) &&
                              //             ele?.video.length > 0
                              //             ? ele?.video?.length
                              //             : 0}{" "}
                              //           videos
                              //         </p>
                              //       </Col>
                              //     </Row>
                              //   </div>
                              // </Col>
                              <Col lg={12} className="mt-2" key={index}>
                                <div
                                  className="collection-video-inner"
                                  onClick={() => handleClick(ele)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <Row>
                                    <Col lg={3} md={3} sm={3} xs={4}>
                                      <img
                                        key={ele?._id}
                                        src={
                                          ele?.image
                                            ? ele?.image
                                            : require("../Assets/Images/clogo.png")
                                        }
                                        alt={ele?.name}
                                        onError={(e) => {
                                          e.target.src = require("../Assets/Images/clogo.png"); // Fallback to default image
                                        }}
                                      />
                                    </Col>
                                    <Col
                                      lg={6}
                                      md={7}
                                      sm={7}
                                      xs={6}
                                      className=""
                                    >
                                      <div className="count-section">
                                        <h3>{ele.name}</h3>
                                        <div className="collections-desc">
                                          <p
                                            style={{
                                              fontSize: "10px",
                                              color: "#2B3674",
                                              margin: "0 0 5px 0",
                                              lineHeight: "14px",
                                              wordBreak: "break-word",
                                              whiteSpace: "normal",
                                            }}
                                          >
                                            Created by:{" "}
                                            <>
                                              {ele?.createdBy === "Teacher" && (
                                                <>
                                                  {ele?.teacherId?.firstName}{" "}
                                                  {ele?.teacherId?.surName}
                                                </>
                                              )}

                                              {ele?.createdBy === "School" && (
                                                <>{ele?.schoolId?.schoolName}</>
                                              )}

                                              {ele?.createdBy ===
                                                "SchoolAdmin" && (
                                                <>
                                                  {
                                                    ele?.schoolAdminId
                                                      ?.firstName
                                                  }{" "}
                                                  {ele?.schoolAdminId?.surName}
                                                </>
                                              )}
                                              {ele?.createdBy === "Student" && (
                                                <>
                                                  {ele?.studentId?.name}
                                                  {
                                                    ele?.studentId?.firstName
                                                  }{" "}
                                                  {ele?.studentId?.surName}
                                                </>
                                              )}
                                            </>
                                          </p>
                                        </div>
                                        <div className="count-desc pt-1  ">
                                          <p>
                                            Shared with{" "}
                                            {ele?.sharedWithStudentsCount ?? 0}{" "}
                                            student
                                            {ele?.sharedWithStudentsCount === 1
                                              ? ""
                                              : "s"}
                                          </p>
                                          <p>
                                            Shared with{" "}
                                            {ele?.sharedWithTeachersOrAdminsCount ??
                                              0}{" "}
                                            teacher
                                            {ele?.sharedWithTeachersOrAdminsCount ===
                                            1
                                              ? ""
                                              : "s"}
                                          </p>
                                        </div>
                                      </div>
                                      <p>
                                        Created on{" "}
                                        {ele?.createdAt
                                          ? moment(ele?.createdAt).format(
                                              "DD/MM/YYYY"
                                            )
                                          : null}
                                      </p>
                                    </Col>
                                    <Col
                                      lg={3}
                                      md={2}
                                      sm={2}
                                      xs={2}
                                      className="video-count-sec"
                                    >
                                      <div className="videos-count">
                                        <p className="text-end">
                                          {Array.isArray(ele?.video) &&
                                          ele?.video.length > 0
                                            ? ele?.video?.length
                                            : 0}{" "}
                                          videos
                                        </p>
                                      </div>
                                      <div className="security-sec bottom-0 d-flex gap-2 ">
                                        {ele?.accessType == "PUBLIC" && (
                                          <>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="11"
                                              height="14"
                                              viewBox="0 0 11 14"
                                              fill="none"
                                            >
                                              <rect
                                                x="1"
                                                y="5.6152"
                                                width="9.23077"
                                                height="7.38474"
                                                rx="1"
                                                stroke="#201A46"
                                                strokeWidth="0.8"
                                                stroke-linejoin="round"
                                              />
                                              <rect
                                                x="4.75"
                                                y="8.50015"
                                                width="1.49944"
                                                height="1.49946"
                                                rx="0.74972"
                                                stroke="#201A46"
                                                strokeWidth="0.8"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M7.92398 2.97805V2.97805C7.92398 1.88561 7.03838 1 5.94593 1H5.61629C4.34178 1 3.30859 2.03319 3.30859 3.30769V5.61546H5.61629"
                                                stroke="#201A46"
                                                strokeWidth="0.8"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                            <p>Public</p>
                                          </>
                                        )}
                                        {ele?.accessType == "PRIVATE_GROUP" && (
                                          <>
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="24"
                                              height="24"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                            >
                                              <circle
                                                cx="9.5"
                                                cy="12.5"
                                                r="2.5"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <path
                                                d="M14 19.75C14 21.8211 11.5711 22 9.5 22C7.42893 22 5 21.8211 5 19.75C5 17.6789 7.42893 16 9.5 16C11.5711 16 14 17.6789 14 19.75Z"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <path
                                                d="M13.5527 14.7711C14.6631 14.7711 15.5633 13.8709 15.5633 12.7605C15.5633 11.6501 14.6631 10.75 13.5527 10.75"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <path
                                                d="M16.5685 18.9999C16.5685 17.2252 15.2379 15.6654 13.5527 14.771"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <path
                                                d="M5.01562 14.7711C3.90524 14.7711 3.00509 13.8709 3.00509 12.7605C3.00509 11.6501 3.90524 10.75 5.01562 10.75"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <path
                                                d="M1.99982 18.9999C1.99982 17.2252 3.33042 15.6654 5.01562 14.771"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                              />
                                              <rect
                                                x="15"
                                                y="4.15356"
                                                width="6.30769"
                                                height="5.04615"
                                                rx="1"
                                                stroke="#99A1BB"
                                                stroke-linejoin="round"
                                              />
                                              <rect
                                                x="17.5625"
                                                y="6.125"
                                                width="1.025"
                                                height="1.025"
                                                rx="0.5125"
                                                stroke="#99A1BB"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M16.5781 2.57692C16.5781 1.70601 17.2841 1 18.155 1V1C19.026 1 19.732 1.70601 19.732 2.57692V4.15385H18.155H16.5781V2.57692Z"
                                                stroke="#99A1BB"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                            <p>Share Only</p>
                                          </>
                                        )}
                                        {ele?.accessType == "PRIVATE" && (
                                          <>
                                            <svg
                                              className="private"
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="20"
                                              viewBox="0 0 16 20"
                                              fill="none"
                                            >
                                              <rect
                                                x="1"
                                                y="8"
                                                width="14"
                                                height="11.2"
                                                rx="1"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linejoin="round"
                                              />
                                              <rect
                                                x="6.6875"
                                                y="12.375"
                                                width="2.275"
                                                height="2.275"
                                                rx="1.1375"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linejoin="round"
                                              />
                                              <path
                                                d="M4.5 4.5C4.5 2.567 6.067 1 8 1V1C9.933 1 11.5 2.567 11.5 4.5V8H8H4.5V4.5Z"
                                                stroke="#99A1BB"
                                                strokeWidth="1.5"
                                                stroke-linejoin="round"
                                              />
                                            </svg>
                                            <p>Private</p>
                                          </>
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            ))}
                          </>
                        ) : (
                          <Container fluid>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "400px",
                              }}
                            >
                              <p className="data-not-found-cmn">
                                No Data Found
                              </p>
                            </div>
                          </Container>
                        )}
                      </>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col xxl={4} md={12} className="display-table">
                <div className="cmn-card-color teacher table-cell">
                  <div className="d-flex justify-content-between">
                    <h2 className="f-24">All Classes</h2>
                  </div>
                  <div className="scroll-add">
                    {adminDetail &&
                    Array.isArray(adminDetail?.classId) &&
                    adminDetail?.classId?.length > 0 ? (
                      <>
                        {adminDetail.classId.map((ele, index) => {
                          return (
                            <Row key={index}>
                              <Col lg={6} className="mt-2">
                                <div className="classes-inner">
                                  <p className="text-right">8 students</p>
                                  <h3>Year {ele?.group}</h3>
                                  <h2>{ele?.name}</h2>
                                </div>
                              </Col>
                            </Row>
                          );
                        })}
                      </>
                    ) : (
                      <Row>
                        <p className="data-not-found-cmn"> No Data Found</p>
                      </Row>
                    )}
                  </div>
                </div>
              </Col>
              <Col xxl={4} md={12} className="display-table mt-4">
                <div className="cmn-card-color table-cell">
                  <div className="details-chart">
                    <div>
                      <div className="">
                        <p>Daily Usage</p>
                        <h5>
                          {convertTime(Math.trunc(WeekCount))}
                          <span>Average</span>
                        </h5>
                      </div>
                      <WeekPicker setSelectedDates={setSelecteDates} />
                    </div>
                  </div>
                  <Users
                    setWeekCount={setWeekCount}
                    selecteDates={selecteDates}
                    selectedWeek={selectedWeek}
                    type="teacher"
                    idval={idval}
                  />
                </div>
              </Col>
              <Col
                xxl={8}
                lg={8}
                md={12}
                sm={12}
                className="mt-4 display-table "
              >
                <div className="cmn-card-color table-cell">
                  <div className="table-box-cmn">
                    <div className="results-sec">
                      <Row>
                        <Col
                          lg={12}
                          className="d-flex align-items-center justify-content-between"
                        >
                          <Col md={6} sm={12} className="table-heading d-flex">
                            <h2>Related Learners</h2>
                            <h2 className="ms-1">
                              (
                              {Array.isArray(adminDetail?.studentId) &&
                              adminDetail?.studentId?.length > 0
                                ? adminDetail?.studentId?.length
                                : 0}
                              )
                            </h2>
                          </Col>
                          <Col md={6} sm={12} className="search-bar-sec">
                            <input type="search" placeholder="Search" />
                            <button
                              type="button"
                              onClick={handleOpenStudentModal}
                              style={{background:'#d200a5'}}
                            >
                              <svg
                                width="19"
                                height="17"
                                viewBox="0 0 19 17"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g clipPath="url(#clip0_162_26721)">
                                  <path
                                    d="M9.82715 3.71582V13.2783"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M14.8896 8.49707H4.76465"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_162_26721">
                                    <rect
                                      width="18"
                                      height="17"
                                      fill="white"
                                      transform="translate(0.827148 -0.00292969)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                          </Col>
                        </Col>
                      </Row>
                    </div>
                    <div className="table-responsive">
                      <Table size="sm" className="table-cmn mt-3">
                        <thead>
                          <tr>
                            <th>
                              <span>#</span>
                            </th>
                            <th>
                              <span>Avatar</span>
                            </th>
                            <th>
                              <span>Username</span>
                            </th>
                            <th>
                              <span>Connected</span>
                            </th>

                            <th>
                              <span>Last Active</span>
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {adminDetail &&
                          Array.isArray(adminDetail?.studentId) &&
                          adminDetail?.studentId?.length > 0 ? (
                            <>
                              {adminDetail.studentId.map((ele, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{ele?.sr_no}</td>
                                    <td>
                                      <img
                                        src={require("../Assets/Images/girl.png")}
                                      />
                                    </td>
                                    <td>{ele?.userName}</td>
                                    <td>
                                      {ele?.createdAt
                                        ? moment(ele.createdAt).format(
                                            "DD/MM/YYYY"
                                          )
                                        : null}
                                    </td>
                                    <td>
                                      {ele?.updatedAt
                                        ? moment(ele.updatedAt).format(
                                            "DD/MM/YYYY"
                                          )
                                        : null}
                                    </td>
                                    <td
                                      onClick={() => handleDetailClick(ele)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      View
                                    </td>
                                  </tr>
                                );
                              })}
                            </>
                          ) : (
                            <Row>
                              <p className="data-not-found-cmn">
                                {" "}
                                No Data Found
                              </p>
                            </Row>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={6} lg={12} className="mt-4 display-table">
                <div className="cmn-card-color table-cell">
                  <h2 className="f-24">Search History</h2>
                  <div className="Search History">
                    {Array.isArray(adminDetail?.searched) &&
                    adminDetail?.searched?.length > 0 ? (
                      adminDetail?.searched.map((res, index) => {
                        return (
                          <>
                            <div
                              className="search-history-main mt-3"
                              key={index}
                            >
                              <h6>{res.searched}</h6>
                              <p>
                                {res?.createdAt
                                  ? moment(res?.createdAt).format("DD/MM/YYYY")
                                  : null}
                              </p>
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <p className="data-not-found-cmn">Data Not Found</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xxl={6} lg={12} className="mt-4 display-table">
                <div className="cmn-card-color table-cell">
                  <h2 className="f-24">Recent Viewing History</h2>
                  <div className="Review-history mt-3">
                    {adminDetail &&
                    Array.isArray(adminDetail?.history) &&
                    adminDetail?.history?.length > 0 ? (
                      adminDetail?.history.map((res, index) => {
                        return (
                          <>
                            <Row key={index} className="mb-3">
                              <Col lg={1} md={2} sm={2}>
                                <img
                                  src={
                                    res?.video?.cover_url
                                      ? res?.video?.cover_url
                                      : null
                                  }
                                />
                              </Col>
                              <Col
                                lg={8}
                                md={7}
                                sm={7}
                                className="d-flex justify-content-center flex-column view-history"
                              >
                                <h3>{res?.video?.title}</h3>
                                <p>{res?.video?.categoryId?.title}</p>
                              </Col>
                              <Col
                                lg={3}
                                md={3}
                                sm={3}
                                className="d-flex align-items-center justify-content-end"
                              >
                                <p>
                                  {res?.createdAt
                                    ? moment(res.createdAt).format("DD/MM/YYYY")
                                    : null}
                                </p>
                              </Col>
                            </Row>
                          </>
                        );
                      })
                    ) : (
                      <p className="data-not-found-cmn">Data Not Found</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </>
      )}
      <CreateAdminModal
        showCreate={showCreate}
        handleCloseCreate={handleCloseCreate}
        editdata={adminDetail}
      />
      <ConfirmModal
        data={adminDetail}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
      />
    </Layout>
  );
}
